import { stats } from "@/mocks/melonData";
import { SectionShell } from "./brand";

export default function StatsBar() {
  return (
    <SectionShell id="stats" className="py-12 md:py-16">
      <div className="grid grid-cols-2 gap-3 md:grid-cols-5 md:gap-4">
        {stats.map((s, i) => (
          <div
            key={s.key}
            className={`rounded-2xl border p-5 md:p-6 ${
              i === 0
                ? "border-accent-200 bg-accent-100/60"
                : "border-background-200 bg-background-100"
            }`}
          >
            <p className="text-xs text-secondary-800">{s.key}</p>
            <p className="mt-2 flex items-end gap-1 font-heading text-3xl md:text-4xl text-foreground-950">
              {s.value}
              <span className="text-sm text-foreground-600">{s.suffix}</span>
            </p>
            <p className="mt-1.5 text-xs text-foreground-500">{s.note}</p>
          </div>
        ))}
      </div>
    </SectionShell>
  );
}